// Resolves which union a logged-in union-side account acts as -- the union counterpart of
// resolveEmployerId. Only the original union signup's own auth.uid() equals union_accounts.id;
// an invited union_staff seat has a different auth.uid() but acts on the owner's union_id.
export async function resolveUnionId(supabase, userId) {
  // is_active is a real access gate, not a display flag: a deactivated seat resolves to no
  // union at all (and union_staff's SELECT policy hides the row from them anyway), so every
  // caller turns them away rather than rendering union chrome for someone switched off.
  const { data: staffRow } = await supabase.from('union_staff').select('union_id').eq('user_id', userId).eq('is_active', true).maybeSingle();
  if (staffRow?.union_id) return staffRow.union_id;

  // Fallback/self-heal: an owner whose union_staff row is missing (signed up before this
  // feature, or the signup RPC call failed) is still the owner if union_accounts.id matches
  // their own uid -- repair the missing row so future loads don't need this fallback.
  const { data: ownerRow } = await supabase.from('union_accounts').select('id').eq('id', userId).maybeSingle();
  if (ownerRow) {
    await supabase.rpc('bootstrap_union_owner_staff');
    return ownerRow.id;
  }
  return null;
}

// Invited union staff sign up through /union/join with this marker in their auth metadata.
// Routing/UX only (never authorization -- RLS on is_union_staff is the real gate): it lets
// login send a *deactivated* staff member to the union dashboard's "access deactivated"
// state instead of silently dropping them into the worker flow.
export const UNION_STAFF_ROLE = 'union_staff';
